import { Component, computed, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ProductCardItem } from './product-card-item.model';
import { ImgFallbackDirective } from '../../directives/img-fallback.directive';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [CommonModule, RouterLink, ImgFallbackDirective],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss',
})
export class ProductCardComponent {
  @Input({ required: true }) product!: ProductCardItem;

  readonly detailUrl = computed(() => {
    return ['/product-detail', this.product.kind, this.product.id];
  });

  chipText(): string {
    return [this.product.chip1, this.product.chip2, this.product.chip3].filter(Boolean).join(' · ');
  }

}
